import { render } from "./MenuEditor.vue?vue&type=template&id=5896b763&scoped=true"
import script from "./MenuEditor.vue?vue&type=script&lang=js"
export * from "./MenuEditor.vue?vue&type=script&lang=js"

import "./MenuEditor.vue?vue&type=style&index=0&id=5896b763&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5896b763"]])

export default __exports__